const plugin = require('tailwindcss/plugin');
const selectorParser = require('postcss-selector-parser');

module.exports = {
    purge: {
        content: [
            './templates/**/*.ftl',
            './includes/templates/*.ftl',
            './macros/*.ftl',
            './lib/*.ftl',
            './ts/**/*.vue',
            // also include the stuff in the selecta module because only a portion of templates is included in this module
            '../selecta/templates/**/*.ftl',
            '../selecta/includes/templates/*.ftl',
            '../selecta/macros/*.ftl',
            '../selecta/lib/*.ftl',
            '../selecta/ts/**/*.vue'
        ],
        options: {
            safelist: [
                'flex-1/1',
                'flex-1/2',
                'flex-1/3',
                'flex-1/4',
                'kicker--only-icon'
            ]
        }
    },
    darkMode: false, // or 'media' or 'class'
    corePlugins: {
        container: false
    },
    theme: {
        extend: {
            backgroundImage: {
                check: 'url(\'../assets/img/check.svg\')'
            },
            borderRadius: {
                mid: '.625rem',
                large: '1.25rem',
                xlarge: '2.25rem',
                ultra: '3.75rem'
            },
            boxShadow: {
                notch: '0 -10px 0 0 #fff'
            },
            colors: {
                white: '#FFFFFF',
                'light-gray': '#F2F2F2',
                gray: {
                    DEFAULT: '#7F7F7F',
                    100: '#f2f2f280'
                },
                black: '#000000',
                'light-red': '#F26B5B',
                red: '#E10718',
                'dark-red': '#70040C',
                teal: '#1A839A',
                purple: '#50037F',
                green: '#00770E'
            },
            fontFamily: {
                sans: ['Helvetica Neue', 'Helvetica', 'Roboto', 'sans-serif'],
                heading: ['Prometo', 'sans-serif']
            },
            fontSize: {
                stage: ['7.25rem', '1'],
                big: ['5rem', '1.2'],
                h1: ['3.375rem', '1.2'],
                h2: ['2.5rem', '1.2'],
                h3: ['2rem', '1.2'],
                story: ['1.75rem', '2.375rem'],
                lg: ['1.25rem', '1.2'],
                sm: ['.875rem', '1.25rem'],
                xs: ['.75rem', '1.25rem']
            },
            gridTemplateRows: {
                footer: 'auto 1fr'
            },
            width: {
                fit: 'fit-content',
                popup: '450px'
            },
            height: {
                '7/10': '70%',
                '3/10': '30%',
                '90dvh': '90dvh',
                dvh: '100dvh',
                intro: 'calc(100dvh - 74px - 80px - 34px)',
                stage: 'calc(100dvh - 138px - 31px)'
            },
            minWidth: {
                33: '8.25rem',
                29: '7.25rem'
            },
            maxWidth: {
                container: '1468px',
                36: '144px',
                75: '300px',
                375: '1500px',
                0: '0rem',
                14.5: '3.625rem',
                40: '10rem',
                64: '16rem'
            },
            minHeight: {
                stage: 'calc(100dvh - 74px - 34px)',
                intro: '600px',
                38: '9.5rem',
                80: '40rem'
            },
            maxHeight: {
                '60dvh': '60dvh',
                '75dvh': '75dvh'
            },
            padding: {
                '20vh': '20vh',
                '3/2': '66.67%',
                '4/3': '75%',
                '3/4': '133.33%',
                '4/5': '125%',
                '5/6': '120%',
                '16/9': '56.25%',
                '21/9': 'calc(9/21 * 100%)',
                full: '100%'
            },
            flex: {
                '1/1': '1 1 100%',
                '1/2': '1 1 50%',
                '1/3': '1 1 33%',
                '1/4': '1 1 25%'
            },
            inset: {
                '1/6': '16.667%'
            },
            margin: {
                '-50vw': '-50vw'
            },
            typography: (theme) => ({
                DEFAULT: {
                    css: {
                        color: 'inherit',
                        a: {
                            color: theme('colors.red')
                        },
                        'a:hover': {
                            color: theme('colors.dark-red')
                        }
                    }
                },
                keys: {
                    css: {
                        li: {
                            display: 'flex',
                            padding: '.75rem 0'
                        },
                        'li::before': {
                            content: 'url("data:image/svg+xml,%3Csvg%20width%3D%2220%22%20height%3D%2220%22%20viewBox%3D%220%200%2024%2024%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22m22.682%205.711-4.394-4.394a4.47%204.47%200%200%200-3.182-1.318H8.893a4.47%204.47%200%200%200-3.182%201.318L1.318%205.711A4.47%204.47%200%200%200%200%208.893v6.213c0%201.202.468%202.333%201.318%203.182l4.394%204.394A4.47%204.47%200%200%200%208.894%2024h6.213a4.47%204.47%200%200%200%203.182-1.318l4.394-4.394a4.47%204.47%200%200%200%201.318-3.182V8.893a4.47%204.47%200%200%200-1.318-3.182ZM23%2015.106c0%20.935-.364%201.814-1.025%202.475l-4.394%204.394A3.48%203.48%200%200%201%2015.106%2023H8.893a3.48%203.48%200%200%201-2.475-1.025l-4.394-4.394a3.48%203.48%200%200%201-1.025-2.475V8.893c0-.935.364-1.814%201.025-2.475l4.394-4.393A3.48%203.48%200%200%201%208.893%201h6.213c.935%200%201.814.364%202.475%201.025l4.394%204.394A3.48%203.48%200%200%201%2023%208.894zm-5.021-6.895a.5.5%200%200%201%200%20.707l-5.309%205.309c-.514.514-1.19.771-1.865.771s-1.351-.257-1.865-.771l-2.864-2.864a.5.5%200%200%201%20.707-.707l2.864%202.864a1.64%201.64%200%200%200%202.316%200l5.309-5.309a.5.5%200%200%201%20.707%200%22%2F%3E%3C%2Fsvg%3E")',
                            display: 'inline-block',
                            position: 'relative',
                            top: '.125rem',
                            marginRight: '1rem'
                        }
                    }
                },
                highlights: {
                    css: {
                        li: {
                            display: 'flex',
                            padding: '.75rem 0'
                        },
                        'li::before': {
                            content: 'url("data:image/svg+xml,%3Csvg%20fill%3D%22none%22%20height%3D%2220%22%20viewBox%3D%220%200%2020%2020%22%20width%3D%2220%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M16.25%2020h-2.5a.413.413%200%200%201-.417-.417c0-.233.184-.416.417-.416h2.5a2.92%202.92%200%200%200%202.917-2.917v-2.5c0-.233.183-.417.416-.417.234%200%20.417.184.417.417v2.5A3.756%203.756%200%200%201%2016.25%2020m-10%200h-2.5A3.756%203.756%200%200%201%200%2016.25v-2.5c0-.233.183-.417.417-.417s.416.184.416.417v2.5a2.92%202.92%200%200%200%202.917%202.917h2.5c.233%200%20.417.183.417.416A.413.413%200%200%201%206.25%2020m1.033-5.833a.827.827%200%200%201-.792-1.083l.784-2.509L5.3%208.967a.84.84%200%200%201-.25-.925.83.83%200%200%201%20.783-.542h2.5l.884-2.375c.116-.317.425-.517.783-.517s.667.2.783.517l.884%202.375h2.5c.35%200%20.666.217.783.55.117.325.025.7-.242.917l-1.975%201.608.817%202.483a.82.82%200%200%201-.283.917.83.83%200%200%201-.959.042l-2.3-1.492-2.258%201.508a.87.87%200%200%201-.467.142zm-1.45-5.842L8.017%2010.1a.42.42%200%200%201%20.133.45l-.867%202.783%202.484-1.658a.42.42%200%200%201%20.458%200l2.525%201.642-.908-2.759a.42.42%200%200%201%20.133-.45l2.192-1.783h-2.8a.395.395%200%200%201-.392-.267l-.983-2.65-.984%202.65a.41.41%200%200%201-.391.275H5.825zm13.75-1.658a.413.413%200%200%201-.416-.417v-2.5A2.92%202.92%200%200%200%2016.25.833h-2.5a.413.413%200%200%201-.417-.416c0-.234.184-.417.417-.417h2.5A3.756%203.756%200%200%201%2020%203.75v2.5a.413.413%200%200%201-.417.417m-19.166%200A.413.413%200%200%201%200%206.25v-2.5A3.756%203.756%200%200%201%203.75%200h2.5c.233%200%20.417.183.417.417a.413.413%200%200%201-.417.416h-2.5A2.92%202.92%200%200%200%20.833%203.75v2.5a.413.413%200%200%201-.416.417%22%20fill%3D%22%23000%22%2F%3E%3C%2Fsvg%3E")',
                            display: 'inline-block',
                            position: 'relative',
                            top: '.125rem',
                            marginRight: '1rem'
                        }
                    }
                },
                story: {
                    css: {
                        a: {
                            textDecoration: 'none',
                            fontWeight: 'inherit'
                        },
                        strong: {
                            display: 'block',
                            fontWeight: 'inherit',
                            marginLeft: '-1rem',
                            paddingLeft: '1rem',
                            borderLeft: '1px solid #E10718'
                        }
                    }
                }
            }),
            screens: {
                '2xl': '1444px'
            },
            spacing: {
                nav: '74px',
                1.25: '0.313rem',
                1.75: '0.438rem',
                2.75: '0.6875rem',
                3.75: '0.938rem',
                4.5: '1.125rem',
                8.5: '2.125rem',
                13: '3.25rem',
                15: '3.75rem',
                15.5: '3.875rem',
                17: '4.25rem',
                18: '4.5rem',
                21: '5.25rem',
                22: '5.5rem',
                25: '6.25rem',
                26: '6.5rem',
                30: '7.5rem',
                33: '8.25rem',
                34: '8.5rem',
                75: '18.75rem',
                150: '37.5rem'
            },
            zIndex: {
                '-1': '-1'
            },
            keyframes: {
                'bounce-50': {
                    '0%': { transform: 'translateY(0)' },
                    '50%': { transform: 'translateY(-5px)' },
                    '100%': { transform: 'translateY(0)' }
                },
                'width-full': {
                    '100%': { width: '100%' }
                }
            },
            animation: {
                bounce: 'bounce-50 1s ease 1',
                'width-full': 'width-full 5s ease-out forwards'

            },
            scale: {
                '-100': '-1',
                25: '0.25',
                180: '1.8'
            },
            gradientColorStops: {
                'black/60': 'rgba(0,0,0,0.6)',
                'black/70': 'rgba(0,0,0,0.7)'
            },
            transitionDuration: {
                5000: '5000ms'
            },
            borderWidth: {
                10: '10px'
            }
        },
        parents: ['cg']
    },
    variants: {
        extend: {
            animation: ['hover', 'group-hover'],
            backgroundColor: ['important', 'active-slide', 'group-hover', 'hover'],
            backgroundOrigin: ['hover'],
            borderColor: ['valid', 'invalid'],
            borderRadius: ['parent'],
            borderWidth: ['first', 'last'],
            brightness: ['hover', 'group-hover'],
            fontSize: ['parent'],
            fontWeight: ['important'],
            grayscale: ['hover'],
            invert: ['hover', 'group-hover'],
            opacity: ['group-hover', 'hover', 'active-slide'],
            overflow: ['important'],
            scale: ['group-hover'],
            sepia: ['hover', 'group-hover'],
            saturate: ['hover', 'group-hover'],
            textColor: [
                'hover',
                'important',
                'group-hover',
                'responsive',
                'active-slide'
            ],
            translate: ['group-hover'],
            width: ['even', 'odd', 'important'],
            margin: ['active-slide', 'important', 'parent'],
            padding: [
                'important',
                'hover',
                'group-hover',
                'active-slide',
                'parent'
            ],
            display: ['active-slide', 'important'],
            filter: ['hover', 'group-hover']
        }
    },
    plugins: [
        require('@tailwindcss/line-clamp'),
        require('@tailwindcss/typography'),
        plugin(({ addVariant, prefix, e, theme }) => {
            // add variant to make utilities use !important
            addVariant('important', ({ container }) => {
                container.walkRules(rule => {
                    rule.selector = `.\\!${rule.selector.slice(1)}`;
                    rule.walkDecls(decl => {
                        decl.important = true;
                    });
                });
            });
            addVariant('active-slide', ({ modifySelectors, separator }) => {
                modifySelectors(({ className }) => {
                    return `.slide-active .${e(`active-slide${separator}${className}`)}, .slide-active.${e(`active-slide${separator}${className}`)}`;
                });
            });
            addVariant('valid', ({ modifySelectors, separator }) => {
                modifySelectors(({ className }) => {
                    return `.${e(`valid${separator}${className}`)}:valid:not(:placeholder-shown)`;
                });
            });
            addVariant('invalid', ({ modifySelectors, separator }) => {
                modifySelectors(({ className }) => {
                    return `.${e(`invalid${separator}${className}`)}[data-touched]:invalid`;
                });
            });
            addVariant('parent', ({ modifySelectors, separator }) => {
                modifySelectors(({ className }) => {
                    return `.parent .${e(`parent${separator}${className}`)}`;
                });
            });

            const parents = theme('parents') || [];

            addVariant('parent', ({ modifySelectors, separator }) => {
                return modifySelectors(({ selector }) => {
                    return selectorParser((root) => {
                        root.walkClasses((node) => {
                            const value = node.value;
                            parents.forEach((parent) => {
                                node.parent.parent.insertAfter(
                                    node.parent,
                                    selectorParser().astSync(
                                        prefix(`.parent-${parent} .`) +
                                        e(`parent-${parent}${separator}${value}`)
                                    )
                                );
                            });
                        });
                    }).processSync(selector);
                });
            });
        })
    ]
};
